// DesktopHomepage.tsx
import React, { useState } from "react";
import "./DesktopHomepage.css";
import LandingPage from "../../Common/LandingPage/LandingPage";
import Footer from "../../../components/Footer/Footer";
import { useTheme } from "@emotion/react";
import { useMobileTopSpacerColor } from "../../../hooks/useMobileTopSpacerColor";

const DesktopHomepage: React.FC = () => {
  const theme: any = useTheme();
  const spacerColor = theme?.background ?? theme?.mainBackground ?? "#f6eee2";
  useMobileTopSpacerColor(spacerColor);
  return (
    <div
      className="desktop-homepage"
      style={{ backgroundColor: theme.background }}
    >
      <LandingPage />
      <Footer />
    </div>
  );
};

export default DesktopHomepage;
